import React  from 'react';  

export const selfHelpConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        path: "/AppSelfHelf",
        component: React.lazy(() => import('./AppSelfHelp')),

      },
      {
        path: "/faq",
        component: React.lazy(() => import('./AppFAQ')),

      }
    ],
  },
 
];
